// カテゴリーごとの定数定義
export const CATEGORIES = {
    MANSION: "used_mansion", // マンション
    HOUSE: "house", // 戸建て
    NEW_HOUSE: "new_house", // 新築戸建て
    USED_HOUSE: "used_house", // 中古戸建て
    LAND: "land", // 土地
    INVEST: "invest", // 事業用
};
// マップの初期設定
export const MAP_DEFAULT_CONFIG = {
    center: { lat: 34.6937, lng: 135.5023 },
    zoom: 12,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
};
// クラスタリングの設定
export const CLUSTER_CONFIG = {
    radius: 60, // クラスター形成の範囲（ピクセル）
    maxZoom: 16, // このズームレベル以上ではクラスタリングしない
};
// カテゴリーごとのマーカー色定義
export const MARKER_COLORS = {
    [CATEGORIES.MANSION]: "#FF8147CC", // マンション
    [CATEGORIES.HOUSE]: "#007AFF", // 戸建て
    [CATEGORIES.NEW_HOUSE]: "#007AFF", // 新築戸建て
    [CATEGORIES.USED_HOUSE]: "#007AFF", // 中古戸建て
    [CATEGORIES.LAND]: "#008009CC", // 土地
    [CATEGORIES.INVEST]: "#6B7280", // 事業用
};
// タブの定数
export const TAB_LABELS = {
    [CATEGORIES.LAND]: "土地を探す",
    [CATEGORIES.HOUSE]: "戸建てを探す",
    [CATEGORIES.MANSION]: "事業・投資用を探す",
};

//物件の最大表示数
export const MAX_DISPLAY = 20;
